export default {
      id: "shousuo-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.271d836e.svg#shousuo",
      toString: function () {
        return this.url;
      }
    }